import { render, staticRenderFns } from "./ConfigDistribuicaoProdutoDialog.vue?vue&type=template&id=b860c768&scoped=true"
import script from "./ConfigDistribuicaoProdutoDialog.vue?vue&type=script&lang=js"
export * from "./ConfigDistribuicaoProdutoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b860c768",
  null
  
)

export default component.exports